import { Howl } from 'howler';

export default class ExitModal {
    
    constructor() {
        this.$self = document.querySelector('.js-exit');
        this._init();
    }

    _init(){
        const audio_ext = window.navigator.userAgent.match(/Android/) ? ".ogg" : ".mp3";
        this.sound = new Howl({src: [`./assets/audio/common/click${audio_ext}`]});

        document.querySelector('.js-btn_return').addEventListener('click', ()=>{
            window.PLAYBACK.pause();
            window.PLAYBACK._isRock = true;
        });

        document.querySelector('.js-exit__yes').addEventListener('click', e=>{
            e.preventDefault();

            this.sound.play();
            this.sound.once('end', ()=>{
                location.href = document.querySelector('.js-exit__yes a').href;
            });
        });

        document.querySelector('.js-exit__no').addEventListener('click', ()=>{
            this.sound.play();
            window.PLAYBACK._isRock = false;
            window.PLAYBACK.resume();
        });
    }
}
